<template>
  <div>
    <NurseDashboard v-if="role === 'Nurse'" />
    <LaboratoryScientistDashboard v-if="role === 'Laboratory Scientist'" />
    <DoctorDashboard v-if="role === 'Doctor'" />
    <AdminDashboard v-if="role === 'Administrator'" />
    <AccountantDashboard v-if="role === 'Accountant'" />
    <PasswordReset />
  </div>
</template>
<script>
import PasswordReset from '@components/admin/PasswordReset';
import NurseDashboard from '@components/admin/dashboards/NurseDashboard';
import LaboratoryScientistDashboard from '@components/admin/dashboards/LabScientistDashboard';
import DoctorDashboard from '@components/admin/dashboards/DoctorDashboard';
import AdminDashboard from '@components/admin/dashboards/AdminDashboard';
import AccountantDashboard from '@components/admin/dashboards/AccountantDashboard';

export default {
  name: 'Dashboard',
  components: {
    PasswordReset,
    NurseDashboard,
    LaboratoryScientistDashboard,
    DoctorDashboard,
    AdminDashboard,
    AccountantDashboard
  },
  computed: {
    role() {
      return this.$store.state['vue-auth']?.user?.role || '';
    }
  }
};
</script>
<style scoped></style>
